import $ from "jquery";
import {gsap} from "gsap";
const blocs = $(".multifeatures-spotlight-bloc")
const active_class = 'feature-active';
let anim = false;

const init_multifeatures = () => {
    // init des clics sur les li des listes de features
    const $li = blocs.find("li.features-content-wrapper")
    $li.on('click', (e) => click_li_handler(e));

     const $li_active = $(`ul.features-images-wrapper li.${active_class}`);
     if($li_active.length){
         gsap.set($li_active, {autoAlpha:1});
     }
}

const click_li_handler = (e) => {
    // init des clics sur les li des listes de features
    const $li_clicked = $(e.currentTarget);
    if(!$li_clicked.hasClass(active_class)){
        // On enlève la class feature-active sur tous les li
        const $all_li = $li_clicked.parent().children();
        $all_li.removeClass(active_class);

        // On l'ajoute sur le li cliquée
        $li_clicked.addClass(active_class);

        //index cliqued
        const index = $li_clicked.data('featureindex');
        const $ul_image = $li_clicked.parents('.multifeatures-spotlight-wrapper').children('.col-features-images').children('.features-images-wrapper');
        const $li_image_active = $ul_image.find('li.features-image-wrapper.feature-active');
        const $li_image_to_active = $ul_image.find('li.features-image-wrapper').eq(index - 1);


        anim = gsap.timeline({})
                .to($li_image_active, {autoAlpha:0,y:-20, duration:.2, ease:"power1.out", onComplete:() => {
                        $li_image_active.removeClass(active_class)
                        $li_image_to_active.addClass(active_class)
                    }})
                .fromTo($li_image_to_active, {autoAlpha:0,y:+20}, {autoAlpha:1,y:0, duration:.2, delay:.1, ease:"power1.out"});


    }
}


export {init_multifeatures}